/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLayout9Filled: {
  name: 'layout-9-filled';
  data: string;
} = {
  name: 'layout-9-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.58 3.047c-.733.14-1.4.821-1.537 1.57-.026.145-.043.854-.043 1.81V8h8V3l-3.11.004c-1.78.003-3.195.021-3.31.043M13 12v9h3.073c2.034 0 3.153-.015 3.31-.043.768-.141 1.433-.806 1.574-1.574.061-.334.061-14.432 0-14.766-.141-.768-.806-1.433-1.574-1.574-.157-.028-1.276-.043-3.31-.043H13zM3 12v2h8v-4H3zm0 5.573c0 .956.017 1.665.043 1.81.141.768.806 1.433 1.574 1.574.157.028 1.276.043 3.31.043H11v-5H3z"/></svg>`
};
